import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  provinceStock: { error: null, loading: false, data: [] },
  ProvinceIps: { error: null, loading: false, data: [] },
  ProvinceItemCategoires: { error: null, loading: false, data: [] },
  ProvinceCommodityClassifications: { error: null, loading: false, data: [] },
  ProvinceCurrencies: { error: null, loading: false, data: [] },
  ProvinceItems: { error: null, loading: false, data: [] },
  ProvinceInItems: { data: [], error: null, loading: null },
  ProvinceOutItems: { data: [], error: null, loading: null },
  provinceWarehouses: { error: null, loading: false, data: [] },
  provinceProvinces: { error: null, loading: false, data: [] },
  provinceProviders: { error: null, loading: false, data: [] },
  provinceFacilities: { error: null, loading: false, data: [] },
  provinceProjects: { error: null, loading: false, data: [] },
  exportStatus: { loading: false, error: null },
  realtime: {
    config: { loading: false, error: null, data: null },
    exportState: { loading: false, error: null },
  },
  sectionChartData: {
    bar: { loading: false, error: null, data: null, dataset: 'stock', hasData: false },
    line: { loading: false, error: null, data: null, dataset: 'stock', hasData: false },
    pie: { loading: false, error: null, data: null, dataset: 'stock', hasData: false },
    map: { loading: false, error: null, data: null, type: 'receipt', hasData: false },
    stackedBar: { loading: false, error: null, data: null, dataset: 'stock', hasData: false },
  },
};

const provinceDashboardSlice = createSlice({
  name: "provinceDashboard",
  initialState,
  reducers: {
    setProvinceStock(state, action) {
      state.provinceStock = {
        error: action.payload.error,
        loading: action.payload.loading,
        data: action.payload.data,
      };
    },
    setProvinceIps(state, action) {
      state.ProvinceIps = {
        error: action.payload.error,
        loading: action.payload.loading,
        data: action.payload.data,
      };
    },
    setProvinceProjects(state, action) {
      state.provinceProjects = {
        error: action.payload.error,
        loading: action.payload.loading,
        data: action.payload.data,
      };
    },
    setProvinceItemCategories(state, action) {
      state.ProvinceItemCategoires = {
        error: action.payload.error,
        loading: action.payload.loading,
        data: action.payload.data,
      };
    },
    setProvinceCommodityClassifications(state, action) {
      state.ProvinceCommodityClassifications = {
        error: action.payload.error,
        loading: action.payload.loading,
        data: action.payload.data,
      };
    },
    setProvinceCurrencies(state, action) {
      state.ProvinceCurrencies = {
        error: action.payload.error,
        loading: action.payload.loading,
        data: action.payload.data,
      };
    },
    setProvinceItems(state, action) {
      state.ProvinceItems = {
        error: action.payload.error,
        loading: action.payload.loading,
        data: action.payload.data,
      };
    },
    setProvinceInItems(state, action) {
      state.ProvinceInItems = {
        error: action.payload.error,
        loading: action.payload.loading,
        data: action.payload.data,
      };
    },
    setProvinceOutItems(state, action) {
      state.ProvinceOutItems = {
        error: action.payload.error,
        loading: action.payload.loading,
        data: action.payload.data,
      };
    },

    setProvinceWarehouses(state, action) {
      state.provinceWarehouses = {
        error: action.payload.error,
        loading: action.payload.loading,
        data: action.payload.data,
      };
    },
    setProvinceProvinces(state, action) {
      state.provinceProvinces = {
        error: action.payload.error,
        loading: action.payload.loading,
        data: action.payload.data,
      };
    },
    setProvinceProvider(state, action) {
      state.provinceProviders = {
        error: action.payload.error,
        loading: action.payload.loading,
        data: action.payload.data,
      };
    },

    setProvinceFacilities(state, action) {
      state.provinceFacilities = {
        error: action.payload.error,
        loading: action.payload.loading,
        data: action.payload.data,
      };
    },
    setExportStatus(state, action) {
      state.exportStatus = {
        loading: action.payload.loading,
        error: action.payload.error,
      };
    },
    resetProvinceStock(state) {
      state.provinceStock = { error: null, loading: false, data: [] };
    },
    resetProvinceIps(state) {
      state.ProvinceIps = { error: null, loading: false, data: [] };
    },
    resetProvinceItemCategories(state) {
      state.ProvinceItemCategoires = { error: null, loading: false, data: [] };
    },
    resetProvinceCommodityClassifications(state) {
      state.ProvinceCommodityClassifications = { error: null, loading: false, data: [] };
    },
    resetProvinceCurrencies(state) {
      state.ProvinceCurrencies = { error: null, loading: false, data: [] };
    },
    resetProvinceItems(state) {
      state.ProvinceItems = { error: null, loading: false, data: [] };
    },
    resetProvinceInItems(state) {
      state.ProvinceInItems = { data: [], error: null, loading: null };
    },
    resetProvinceOutItems(state) {
      state.ProvinceOutItems = { data: [], error: null, loading: null };
    },

    resetProvinceWarehouses(state) {
      state.provinceWarehouses = { data: [], error: null, loading: null };
    },
    resetProvinceProvinces(state) {
      state.provinceProvinces = { data: [], error: null, loading: null };
    },
    resetProvinceProvider(state) {
      state.provinceProviders = { data: [], error: null, loading: null };
    },

    resetProvinceFacilities(state) {
      state.provinceFacilities = { data: [], error: null, loading: null };
    },
    resetProvinceProjects(state) {
      state.provinceProjects = { data: [], error: null, loading: null };
    },
    resetExportStatus(state) {
      state.exportStatus = { loading: false, error: null };
    },

    // Realtime config
    setRealtimeConfig(state, action) {
      state.realtime.config = action.payload;
    },
    setRealtimeExportState(state, action) {
      state.realtime.exportState = action.payload;
    },

    // Section chart data
    setSectionChartData(state, action) {
      const { section } = action.payload;
      if (section && state.sectionChartData[section] !== undefined) {
        state.sectionChartData[section] = {
          ...state.sectionChartData[section],
          ...action.payload,
        };
      }
    },
    resetSectionChartData(state, action) {
      const section = action.payload;
      if (section && state.sectionChartData[section] !== undefined) {
        const defaults = {
          bar: { loading: false, error: null, data: null, dataset: 'stock', hasData: false },
          line: { loading: false, error: null, data: null, dataset: 'stock', hasData: false },
          pie: { loading: false, error: null, data: null, dataset: 'stock', hasData: false },
          map: { loading: false, error: null, data: null, type: 'receipt', hasData: false },
          stackedBar: { loading: false, error: null, data: null, dataset: 'stock', hasData: false },
        };
        state.sectionChartData[section] = defaults[section] || { loading: false, error: null, data: null };
      }
    },
  },
});

export const provinceDashboardAction = provinceDashboardSlice.actions;

export default provinceDashboardSlice;
